import { SINGLE_LOCATION_FETCH_REQUEST, SINGLE_LOCATION_FETCH_SUCCESS, SINGLE_LOCATION_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    slocation: {},
    error: ''
}

const slocation = (state = initialState, action) => {
    switch (action.type) {
        case SINGLE_LOCATION_FETCH_REQUEST:
            return {
                loading: true,
                slocation: {},
                error: '',
            }
        case SINGLE_LOCATION_FETCH_SUCCESS:
            return {
                loading: false,
                slocation: action.payload,
                error: ''
            }
        case SINGLE_LOCATION_FETCH_FAILURE:
            return {
                loading: false,
                slocation: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default slocation;